import * as React from "react";
import { Redirect, Route, RouteProps, useLocation } from "react-router-dom";
import { UserStatus } from "../../generated/lib-domain/user";
import * as aa from "../../generated/UserAPIAgent";
import { URL_PATHS } from "../../routes";
import { useEffect } from "react";

interface ActiveUserRouteProps extends RouteProps {
    user: aa.User | null;
    children: JSX.Element;
}

const ActiveUserRoute = (props: ActiveUserRouteProps) => {
    const { children, user, ...rest } = props;
    const { pathname } = useLocation();
    useEffect(() => {
        // NOTE ページ遷移時にスクロール位置を上部に戻す
        window.scrollTo(0, 0);
    }, [pathname]);
    return (
        <Route
            {...rest}
            render={({ location }) => {
                if (!user) {
                    return (
                        <Redirect
                            to={{
                                pathname: URL_PATHS.login(),
                                state: { from: location }
                            }}
                        />
                    );
                }
                if (user.status !== UserStatus.Active) {
                    return (
                        <Redirect
                            to={{
                                pathname: URL_PATHS.incompleteRegister(),
                                state: { from: location }
                            }}
                        />
                    );
                }
                return children;
            }}
        />
    );
};

export default ActiveUserRoute;
